<template>
  <MainTemplate>
    <container max-width="950px">
      <preload-content min-height="60vh" :loading="loading">
        <row v-if="!loading && !isMobile">
          <grid-item xs="3">
            <h1>Контакты</h1>
            <ul class="contacts__list">
              <li :key="index" v-for="(item, index) in coworking">
                <b style="cursor: pointer"
                   :class="{'selected-coworking': item.id === selectedCoworking}"
                   @click="onMarket(item.id, [item.latitude, item.longitude])">{{ item.name }}</b>
                <p>{{ item.address }}</p>
              </li>
              <li>
                <button-component @click="nextCoworking" v-if="page !== lastPage" style="cursor: pointer">Еще
                </button-component>
              </li>
            </ul>
          </grid-item>
          <grid-item xs="9">
            <custom-select :value="city || getCity" alue="" @change="changeSelect" mt="30px">
              <option :value="item.id" :key="item.id" v-for="(item) in getCities">{{ item.name }}</option>
            </custom-select>
            <div class="map">
              <yandex-map
                  :coords="coords"
                  :zoom="7">
                <ymap-marker
                    :key="index"
                    v-for="(item, index) in coworking"
                    :coords="[item.latitude, item.longitude]"
                    :marker-id="item.id"
                    hint-content="some hint"
                />
              </yandex-map>
            </div>
          </grid-item>
        </row>
        <div v-else-if="!loading">
          <h1>Контакты</h1>
          <custom-select :value="city || getCity" alue="" @change="changeSelect" mt="30px">
            <option :value="item.id" :key="item.id" v-for="(item) in getCities">{{ item.name }}</option>
          </custom-select>
          <tabs :tabs="tabs" @changeTab="changeTab"/>
          <div v-if="tabs[0].isActive">
            <ul class="contacts__list">
              <li :key="index" v-for="(item, index) in coworking">
                <b style="cursor: pointer"
                   :class="{'selected-coworking': item.id === selectedCoworking}"
                   @click="onMarket(item.id, [item.latitude, item.longitude])">{{ item.name }}</b>
                <p>{{ item.address }}</p>
              </li>
              <li>
                <button-component @click="nextCoworking" v-if="page !== lastPage" style="cursor: pointer">Еще
                </button-component>
              </li>
            </ul>
          </div>
          <div v-if="tabs[1].isActive">
            <div class="map">
              <yandex-map
                  :coords="coords"
                  :zoom="7">
                <ymap-marker
                    :key="index"
                    v-for="(item, index) in coworking"
                    :coords="[item.latitude, item.longitude]"
                    :marker-id="item.id"
                    hint-content="some hint"
                />
              </yandex-map>
            </div>
          </div>
        </div>
      </preload-content>
    </container>
  </MainTemplate>
</template>

<script>
import Row from '../../components/grid/Row'
import Container from '../../components/grid/Container'
import MainTemplate from '../../templates/MainTemplate'
import GridItem from '../../components/grid/GridItem'
import CustomSelect from '../../components/ui/inputs/custom-select'
import {mapGetters} from "vuex";
import {yandexMap, ymapMarker} from 'vue-yandex-maps';
import preloadContent from '../../components/ui/preload-content';
import buttonComponent from '../../components/ui/buttons/button-component';
import Tabs from '@/components/functional/Tabs'

export default {
  name: 'Contacts',
  components: {
    Tabs,
    CustomSelect,
    MainTemplate,
    Container,
    Row,
    GridItem,
    yandexMap,
    ymapMarker,
    preloadContent,
    buttonComponent
  },
  mounted() {
    this.getCoworking();
  },
  methods: {
    onMarket(id, coords) {
      this.selectedCoworking = id;
      this.coords = coords;
    },
    nextCoworking() {
      this.page += 1;
      this.getCoworking();
    },
    getCoworking() {
      this.loading = true;
      this.$api.coworking.list({page: this.page, city_id: this.city || this.getCity, location: true}).then(response => {
        this.coworking.push.apply(this.coworking, response.data);
        this.lastPage = response.meta.last_page;
      }).finally(() => {
        this.loading = false;
      });
    },
    changeSelect(id) {
      this.city = id;
      this.page = 1;
      this.coworking = [];
      this.getCoworking();
    },
    changeTab (idx) {
      this.tabs = this.tabs.map((t, t_idx) => {
        t.isActive = t_idx === idx
        return t
      })
    }
  },
  computed: {
    ...mapGetters(['getCities', "getCity"]),
    isMobile () {
      return document.documentElement.clientWidth < 991
    }
  },
  data: () => ({
    showMore: true,
    coworking: [],
    page: 1,
    lastPage: '',
    city: '',
    selectedCoworking: '',
    loading: true,
    coworkingLatitude: '',
    coworkingLongitude: '',
    coords: [
      54.82896654088406,
      39.831893822753904,
    ],
    settings: {
      apiKey: '',
      lang: 'ru_RU',
      coordorder: 'latlong',
      version: '2.1'
    },
    tabs: [
      {isActive: true, name: 'Список'},
      {isActive: false, name: 'Карта'}
    ]
  })
}
</script>

<style scoped lang="scss">
.selected-coworking {
  color: #DBBFA7 !important;
}

.contacts__list {
  max-height: 60vh;
  overflow-x: auto;
  list-style: none;

  li {
    margin: 20px 0;

    b {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
      margin-bottom: 5px;
    }

    p {
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      line-height: 1.71;
      color: #383838;
    }
  }
}

.ymap-container {
  height: 100%;
}

.map {
  width: 100%;
  height: 500px;
  margin-top: 30px;
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 4px 8px rgba(0, 0, 0, 0.04);
  border-radius: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 991px) {
  h1 {
    font-size: 24px;
    line-height: 1.33;
    margin-bottom: -15px;
    padding-top: 20px;
  }
  .contacts__list {
    max-height: none;
  }
  .map {
    width: calc(100% + 60px);
    margin: 0 -30px;
    height: 320px;
  }
}
</style>
